/**
 * AppSync conflict detection uses VERSION — include `_version` on updateInvoice only when Dynamo has one.
 */
export function finiteInvoiceMutationVersion(version: unknown): number | undefined {
  return typeof version === "number" && Number.isFinite(version) ? version : undefined;
}

export function buildInvoiceUpdateWithOptionalVersion(
  id: string,
  patch: Record<string, unknown>,
  version: unknown
): Record<string, unknown> {
  const v = finiteInvoiceMutationVersion(version);
  const input: Record<string, unknown> = { id, ...patch };
  if (v !== undefined) input._version = v;
  return input;
}
